<div class="buttons">
  <ng-content></ng-content>
</div>
